import { render, staticRenderFns } from "./AffiliateChangeHistoryTable.vue?vue&type=template&id=5341f76c&"
import script from "./AffiliateChangeHistoryTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AffiliateChangeHistoryTable.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AffiliateChangeHistoryTable.vue?vue&type=style&index=0&id=5341f76c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports